const frenchTranslations = {
  mainTitle: "Écrivez un Prompt, Créez un Monde",
  subtitle: "La première animation texte-à-60 secondes en 720p, parfaite à partager avec des amis!",
  // Text prompt card
  promptTitle: "Entrez le Titre du Livre",
  promptSubtitle: "Quelle histoire voulez-vous donner vie?",
  bookPlaceholder: "ex., Le Jardin Secret",
  chooseStyle: "Choisir le Style",
  // Inspiration feature
  needInspiration: "Besoin d'inspiration?",
  selectGenre: "Sélectionnez un genre",
  fantasy: "Fantaisie",
  scienceFiction: "Science-Fiction",
  mystery: "Mystère",
  romance: "Romance",
  historicalFiction: "Fiction Historique",
  getIdea: "Obtenir une Idée",
  loadingIdea: "Recherche d'inspiration...",
  // Steps
  bookTitle: "Titre du Livre",
  style: "Style",
  email: "E-mail",
  // Style picker
  styleTitle: "Choisissez Votre Style",
  styleSubtitle: "Sélectionnez le style d'animation pour votre création",
  continueButton: "Continuer",
  backButton: "Retour",
  // Email checkout
  checkoutTitle: "Votre Création Magique",
  checkoutSubtitle: "Complétez votre commande pour donner vie à votre imagination",
  yourEmail: "Votre E-mail",
  emailPlaceholder: "vous@exemple.com",
  validationMessage: "Veuillez entrer une adresse e-mail valide",
  orderItem: "Vidéo de 60 secondes en style {style}",
  deliveryTime: "Délai de livraison:",
  deliveryTimeValue: "45-55 minutes",
  total: "Total:",
  getAnimation: "Obtenir Mon Animation",
  securePayment: "Paiement sécurisé traité par Stripe",
  
  // Video carousel
  seeTheMagic: "Voir la Magie en Action",
  
  // Disclaimer
  disclaimer: "Avertissement: Cette plateforme est un outil créatif indépendant conçu pour l'expression artistique à travers l'utilisation de l'IA générative. Bien que les résultats visuels ou thématiques puissent parfois ressembler à des styles vus dans les médias populaires ou l'animation, ce produit n'est ni affilié, ni approuvé, ni connecté à aucun studio d'animation, marque de divertissement ou détenteur de propriété intellectuelle.",
  originality: "Toutes les vidéos, images, personnages et scènes générés par cette plateforme sont des créations originales, produites à l'aide de modèles d'IA et de prompts fournis par les utilisateurs. Nous n'utilisons ni n'incorporons aucun personnage, scénario, œuvre d'art, audio ou nom protégé par des droits d'auteur provenant de propriétés intellectuelles existantes dans le comportement par défaut du système ou du modèle.",
  intellectualProperty: "Tous les droits d'auteur, marques déposées et propriétés intellectuelles de tiers référencés ou indirectement évoqués par les utilisateurs restent la propriété exclusive de leurs propriétaires respectifs.",
  userResponsibility: "Les utilisateurs sont seuls responsables de:",
  promptsSubmitted: "Les prompts qu'ils soumettent,",
  contentGenerated: "Le contenu qu'ils choisissent de générer,",
  contentUsage: "Et toute utilisation, distribution ou publication résultante des sorties générées par l'IA.",
  liability: "Nous n'assumons aucune responsabilité pour tout contenu généré, mal utilisé, partagé ou distribué d'une manière qui pourrait violer les droits de propriété intellectuelle, les conditions d'utilisation ou la loi applicable. Cette plateforme est destinée uniquement à la narration originale, l'expérimentation artistique et le plaisir personnel."
};

export default frenchTranslations; 